module.exports = __webpack_public_path__ + "f86581dfd5693c5aa5203d0fad6d8b9b.svg";